import {utils} from '@wallaby-ui/core';
import {createSelector} from 'reselect';

import {CHART_REDUCER_STATE_ID} from './chart_constants';
import {ChartReportConfig} from 'src/js/model/reports_config';
import {RootState} from 'src/js/store';

interface ChartProps {
  propsChartConfigModel?: ChartReportConfig;
  chartId: string;
}

const getPropsChartConfigModelPropsSelector = (
  state: RootState,
  props: ChartProps
) => props?.propsChartConfigModel;

const getChartConfigSelector = (
  state: RootState,
  props: ChartProps
): ChartReportConfig => {
  const chartReducerId = utils.reducerUtils.getInstanceReducerId(
    CHART_REDUCER_STATE_ID,
    props?.chartId
  );
  return state[chartReducerId]?.chartConfig;
};

export const getChartConfig = createSelector(
  [getPropsChartConfigModelPropsSelector, getChartConfigSelector],
  (propsChartConfigModel, chartConfig) => propsChartConfigModel ?? chartConfig
);
